import { useEffect, useState } from "react";
import { Card } from "../../../components/card/card";
import { dataTel3GetList } from "../../../config/apiSPA";
import DateFormat from "../../../components/dateFormater/dateFormat1";
import { Link } from "react-router-dom";
import Pagination3 from "../../../components/pagination/pagination3";
import DataOutstanding from "./dataOutstanding";
const mainDataPreset = {
  data: [],
  meta: null,
};
function Tel3Event() {
  const [mainData, setMainData] = useState(mainDataPreset);
  const [search1Value, setSearch1Value] = useState("");
  const handleNextClick = () => {
    loadData(search1Value, mainData.meta.current_page + 1);
  };
  const handlePrevClick = () => {
    loadData(search1Value, mainData.meta.current_page - 1);
  };
  const handleSubmitSearch = (e) => {
    e.preventDefault();
    loadData(search1Value, "");
  };
  const loadData = async (search = "", page = "") => {
    const resList = await dataTel3GetList(search, page);
    setMainData(resList);
  };
  useEffect(() => {
    loadData();
  }, []);
  return (
    <>
      <div>
        <div className="d-flex align-items-center mb-3">
          <div>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#/">Training Evaluation</a>
              </li>
              <li className="breadcrumb-item active">Event</li>
            </ul>

            <h1 className="page-header">
              Training Evaluation Level 3 <small></small>
            </h1>
          </div>

          <div className="ms-auto">
            <Link to={"/training-evaluation-3/new"} className="btn btn-outline-theme">
              <i className="fa fa-plus-circle fa-fw me-1"></i> New
            </Link>
          </div>
        </div>

        <hr className="mb-1" />
        <div className="p-3">
          <p className="small mb-3">
            Training Evaluation Level 3 (Behavior), conducted <strong>3 months after training</strong> to measure improvements in
            <strong> knowledge, skills, and employee performance</strong>.
          </p>

          <div className="mb-2">
            <strong>Evaluator:</strong>
            <div className="small text-muted">Direct supervisor (minimum Section Head)</div>
          </div>

          <div className="mb-2">
            <strong>Submission:</strong>
            <ul className="small text-muted mb-1 ps-3">
              <li>Learning System & Development Section</li>
              <li>HRG Jobsite (for site-based employees)</li>
            </ul>
          </div>

          <div className="mb-2">
            <strong>Tools:</strong>
            <ul className="small text-muted mb-1 ps-3">
              <li>Form SFP/09/F-006</li>
            </ul>
          </div>

          <div>
            <strong>Scope:</strong>
            <div className="small text-muted">Non-certification Hard Skill training (excluding POP, POM, POU, KJL, BMC, etc.)</div>
          </div>
        </div>
        <div className="mb-3">
          <Card>
            <div className="tab-content p-4">
              {/* ----------------All Tab------------------------------------------------------------------ */}
              <div className="tab-pane fade show active" id="allTab">
                <form onSubmit={handleSubmitSearch}>
                  <div className="input-group mb-4">
                    <div className="d-flex justify-content-end">
                      <div className="input-group">
                        <input onChange={(e) => setSearch1Value(e.target.value)} type="text" className="form-control px-35px" placeholder="Search" />
                        <div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0" style={{ zIndex: 1020 }}>
                          <i className="fa fa-search opacity-5"></i>
                        </div>
                      </div>
                    </div>
                    <button className="btn btn-outline-default" type="submit">
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </form>

                {/* ----------------Table-------------- */}

                <div className="table-responsive">
                  <table className="table table-hover text-nowrap">
                    <thead>
                      <tr>
                        <th className="border-top-0 pt-0 pb-2">Training Title</th>
                        <th className="border-top-0 pt-0 pb-2">Training Code</th>
                        <th className="border-top-0 pt-0 pb-2">Progress</th>
                        <th className="border-top-0 pt-0 pb-2">Instructor</th>
                        <th className="border-top-0 pt-0 pb-2">Start Date</th>
                        <th className="border-top-0 pt-0 pb-2">Event Created</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mainData.data.length > 0 ? (
                        mainData.data.map((val) =>
                          val.progress < 100 ? (
                            <tr key={val.id} className="bg-danger">
                              <td className="align-middle">
                                <Link to={`/training-evaluation-3/detail/${val.id}`}>{val.training.trainingCode.title}</Link>
                              </td>
                              <td className="align-middle">{val.training.trainingCode.code}</td>
                              <td className="align-middle">{val.progress}%</td>
                              <td className="align-middle">{val.training.instructorData.namaInstructor}</td>
                              <td className="align-middle">{DateFormat(val.training.startDate)}</td>
                              <td className="align-middle">{DateFormat(val.created_at)}</td>
                            </tr>
                          ) : (
                            <tr key={val.id}>
                              <td className="align-middle">
                                <Link to={`/training-evaluation-3/detail/${val.id}`}>{val.training.trainingCode.title}</Link>
                              </td>
                              <td className="align-middle">{val.training.trainingCode.code}</td>
                              <td className="align-middle">{val.progress}%</td>
                              <td className="align-middle">{val.training.instructorData.namaInstructor}</td>
                              <td className="align-middle">{DateFormat(val.training.startDate)}</td>
                              <td className="align-middle">{DateFormat(val.created_at)}</td>
                            </tr>
                          ),
                        )
                      ) : (
                        <tr>
                          <td>no data</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* ----------------End Table-------------- */}
              </div>

              {/* ----------------End All Tab------------------------------------------------------------------ */}
              {mainData.meta ? <Pagination3 pageInfo={mainData} nextClick={handleNextClick} prevClick={handlePrevClick} /> : ""}
            </div>
          </Card>
        </div>
        <DataOutstanding />
      </div>
    </>
  );
}

export default Tel3Event;
